import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768; // md do Tailwind

// Decide entre o carrossel lateral (mobile) e a grade paginada (desktop) da
// página inicial — reavalia ao redimensionar a janela.
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return isMobile;
}
